import { useEffect } from 'react';
import { saveViewState } from '../cachedViewState/viewState';
import { useDirectory } from './useDirectory';

export const useSaveDirectoryState = <
  StorageKey extends string = string,
  QueryFilterKey extends string = string,
  QuerySortKey extends string = QueryFilterKey,
>(
  storageKey: StorageKey,
  directoryState: Pick<
    ReturnType<typeof useDirectory<QueryFilterKey, QuerySortKey>>,
    'tableProps' | 'queryParameters' | 'paginationProps'
  >,
) => {
  const { tableProps, queryParameters, paginationProps } = directoryState;

  useEffect(() => {
    const { sort } = tableProps;
    const { page, size, sort: _, ...filters } = queryParameters;
    const { current, pageSize } = paginationProps;
    const state = {
      filters,
      pagination: { current, pageSize },
      sort,
    };
    saveViewState(storageKey, state);
  }, [paginationProps, queryParameters, tableProps, storageKey]);
};
